/* Modal register section, display the modal after post the comment */

document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.comments');

    // Reference to the Register button
    var registerButton = document.getElementById('registerSubmitButton');

    // Check if the container exists
    if (container) {
        var commentsStoreRoute = container.getAttribute('data-route-comments-store');
        var isAuthenticated = container.getAttribute('data-is-authenticated') === 'true';

        var form = document.querySelector('form[action="' + commentsStoreRoute + '"]');
        if (form) {
            form.addEventListener('submit', function (e) {
                if (!isAuthenticated) {
                    e.preventDefault(); // Prevent the form from submitting

                    // Get form data
                    var formData = new FormData(e.target);

                    // Post the comment using AJAX
                    fetch(commentsStoreRoute, {
                        method: 'POST',
                        body: formData,
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest', // to identify this as an AJAX request
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content') // for CSRF protection
                        }
                    })
                        .then(response => {
                            if (response.redirected) {
                                // Comment posted successfully and server responded with a redirect

                                // Get name and email from the comment form
                                var name = document.querySelector('input[name="guest_name"]').value;
                                var email = document.querySelector('input[name="guest_email"]').value;

                                // Populate the registration form in the modal
                                document.getElementById('modalName').value = name;
                                document.getElementById('modalEmail').value = email;

                                // Show the modal
                                $('#registrationModal').modal('show');
                            } else {
                                // Handle errors, e.g., show a message to the user
                                console.error('Error posting comment or unexpected server response');
                            }
                        })
                        .catch(error => {
                            console.error('Error posting comment:', error);
                        });
                }
                // If the user is authenticated, the form will submit normally without the custom behavior
            });
        }
    }
    // Password validation for the registration modal
    var registrationForm = document.querySelector('#registrationModal form');   
    
    // Reference to the placeholder directly
    var passwordErrorDiv = document.getElementById('passwordError');
    if (registrationForm) {
        registrationForm.addEventListener('submit', function (e) {
            var password = document.getElementById('password').value;
            var passwordConfirmation = document.getElementById('password_confirmation').value;

            // Clear previous error messages
            passwordErrorDiv.textContent = '';

            if (password !== passwordConfirmation) {
                e.preventDefault(); // Prevent the form from submitting
                passwordErrorDiv.textContent = 'Passwords does not match!';
                registerButton.disabled = false; // Re-enable the Register button
                return;
            }

            // Check if the password has at least 8 characters
            if (password.length < 8) {
                e.preventDefault(); // Prevent the form from submitting
                passwordErrorDiv.textContent = 'Password must be at least 8 characters long.';
                registerButton.disabled = false; // Re-enable the Register button
                return;
            }

            // Check if the password contains at least one symbol
            var hasSymbol = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password);
            if (!hasSymbol) {
                e.preventDefault(); // Prevent the form from submitting
                passwordErrorDiv.textContent = 'Password must contain at least one symbol.';
                registerButton.disabled = false; // Re-enable the Register button
            }
        });
    }
});

/* Comments section edit form */

window.showEditForm = function (id, editButton) {
    var originalComment = document.getElementById('original-comment-' + id);
    var editComment = document.getElementById('edit-comment-' + id);
    var deleteButton = document.getElementById('delete-button-' + id);
    var replyButton = document.getElementById('reply-button-' + id); 

    if (editComment.style.display === "none") {
        editComment.style.display = "block";
        originalComment.style.display = "none";
        editButton.style.display = "none";
        deleteButton.style.display = "none";
        replyButton.style.display = "none"; 
    } else {
        editComment.style.display = "none";
        originalComment.style.display = "block";
        editButton.style.display = "inline-block";
        deleteButton.style.display = "inline-block";
        replyButton.style.display = "block";
    }
}


window.showReplyForm = function (commentId) {
    var replyForm = document.getElementById('reply-comment-' + commentId);
    if (replyForm.style.display === 'none') {
        replyForm.style.display = '';
    } else {
        replyForm.style.display = 'none';
    }
}
